{
  "organization": {
    "seatOverrun": {
      "title": "A szervezet zárolva van",
      "description": "A szervezetben több felhasználó van, mint ahány hely rendelkezésre áll. Egy szervezeti menedzsernek vagy rendszergazdának meg kell oldania ezt, mielőtt az alkalmazás használható lenne.",
      "seatPool": "Helykeret",
      "resolverDescription": "Függesszen fel vagy töröljön felhasználókat, amíg minden helykeret a korlátján belülre nem kerül.",
      "stuckDescription": "A túltelt helykeretből innen egyetlen hely sem szabadítható fel. Vegye fel a kapcsolatot az ügyfélszolgálattal a helykorlát megemeléséhez.",
      "overBy": "{{over}} a korláton felül",
      "loadError": "A helyadatokat nem sikerült betölteni."
    },
    "tabs": {
      "departments": "Osztályok",
      "functions": "Funkciók",
      "teams": "Csapatok",
      "members": "Személyek",
      "systems": "Rendszerek",
      "externalContacts": "Külső kapcsolatok",
      "artifacts": "Dokumentumok"
    },
    "organigram": {
      "title": "Organigram",
      "description": "Interaktív szervezeti ábra az osztályhierarchiával",
      "empty": "Nem található osztály. Hozzon létre osztályokat az organigram felépítéséhez.",
      "fitView": "Nézethez igazítás",
      "memberCount_one": "{{count}} személy",
      "memberCount_other": "{{count}} személy",
      "manager": "Menedzser",
      "notAssigned": "Nem hozzárendelt",
      "level": "Szint"
    },
    "systems": {
      "title": "Rendszerek",
      "description": "A szervezet összes rendszerének kezelése",
      "empty": "Nem található rendszer",
      "search": "Rendszerek keresése...",
      "softwareSystem": "Szoftverrendszer",
      "category": "Kategória",
      "url": "Hivatkozás a rendszerre",
      "create": "Rendszer létrehozása",
      "editSystem": "Rendszer szerkesztése",
      "createSystemDescription": "Új szoftverrendszer hozzáadása a szervezethez",
      "editSystemDescription": "A szoftverrendszer adatainak frissítése",
      "namePlaceholder": "Adja meg a rendszer nevét",
      "descriptionPlaceholder": "Adja meg a rendszer leírását",
      "categoryPlaceholder": "Adja meg a kategóriát",
      "urlPlaceholder": "https://pelda.hu",
      "systemOwner": "Rendszer tulajdonos",
      "systemOwnerPlaceholder": "Válassza ki a rendszer tulajdonosát...",
      "basicInformation": "Alapinformáció",
      "ownership": "Tulajdonjog",
      "systemDetails": "Rendszer részletei",
      "licenceSeatsLabel": "Licenchelyek",
      "licenceSeatsPlaceholder": "pl. 50",
      "notFound": "Rendszer nem található",
      "noDescription": "Nincs elérhető leírás",
      "saveFailed": "A rendszer mentése nem sikerült",
      "logoUploadFailed": "A rendszer mentése sikerült, de a logó feltöltése nem. A logót később, a rendszer szerkesztésével adhatja hozzá.",
      "stats": {
        "totalUsers": "Összes felhasználó",
        "totalUsersDescription": "A rendszerrel kapcsolatban álló felhasználók",
        "totalOrgFunctions": "Összes funkció",
        "totalOrgFunctionsDescription": "A rendszerrel kapcsolatban álló funkciók",
        "totalRoles": "Összes pozíció",
        "totalRolesDescription": "A felhasználók különböző pozíciói",
        "totalProcesses": "Összes folyamat",
        "totalProcessesDescription": "A rendszert használó folyamatok",
        "capacityBinding": "Kapacitáslekötés",
        "capacityBindingNoData": "Nincs elérhető kapacitásadat",
        "perMonth": "havonta",
        "perYear": "évente",
        "clickToToggle": "kattintson a váltáshoz",
        "costCalculation": "Költségszámítás",
        "costPerMonth": "Költség havonta",
        "costPerYear": "Költség évente",
        "billingRateInfo": "{{rate}}/óra számlázási díj alapján",
        "stepsWithData": "{{count}}/{{total}} lépésnek van kapacitásadata",
        "licenceSeats": "Licenchelyek",
        "licenceSeatsUsed": "Helyek használatban"
      },
      "capacityCell": {
        "monthSuffix": "/hó",
        "yearSuffix": "/év"
      },
      "processesImpacted": {
        "title": "Érintett folyamatok",
        "processName": "Folyamat neve",
        "stepsInvolved": "Érintett lépések",
        "avgRating": "Átlag értékelés",
        "mediaBreaks": "Médiatörések",
        "capacity": "Kapacitás",
        "action": "Művelet",
        "viewSteps": "Lépések megtekintése",
        "noProcesses": "Még nincs a rendszerrel kapcsolatban álló folyamat",
        "stepExplorer": "Lépésfelfedező"
      },
      "systemUsers": {
        "title": "Rendszerfelhasználók",
        "user": "Felhasználó",
        "role": "Pozíció",
        "involvedProcesses": "Érintett folyamatok",
        "noUsers": "Még nincs a rendszerrel kapcsolatban álló felhasználó",
        "searchPlaceholder": "Felhasználók keresése...",
        "filterByRole": "Szűrés pozíció szerint",
        "allRoles": "Összes pozíció",
        "involvementType": {
          "owner": "Tulajdonos",
          "helper": "Segítő",
          "whoElseDoesThis": "Szintén csinálja"
        }
      },
      "topRoles": {
        "title": "Leggyakoribb pozíciók",
        "noRoles": "Nem találhatók pozíciók ehhez a rendszerhez",
        "allRolesTitle": "Összes pozíció"
      },
      "departments": {
        "title": "Osztályok",
        "noDepartments": "Nem találhatók osztályok ehhez a rendszerhez",
        "membersSuffix": "személyek",
        "allDepartmentsTitle": "Összes osztály"
      },
      "topOrgFunctions": {
        "title": "Leggyakoribb funkciók",
        "noOrgFunctions": "Nem találhatók funkciók ehhez a rendszerhez",
        "allOrgFunctionsTitle": "Összes funkció"
      },
      "criticalDependencies": {
        "title": "Kritikus függőségi figyelmeztetés",
        "description": "Ezek a folyamatlépések egyetlen személyre támaszkodnak helyettesítő nélkül. Ha az illető nem elérhető, a lépés nem hajtható végre.",
        "processStep": "Folyamat / Lépés",
        "assignedTo": "Felelős",
        "role": "Pozíció",
        "showAll": "Összes ({{count}}) megjelenítése",
        "showLess": "Kevesebb megjelenítése"
      },
      "interactions": {
        "title": "Rendszerinterakciók",
        "upstream": "UPSTREAM (BEMENET)",
        "downstream": "DOWNSTREAM (KIMENET)",
        "noUpstream": "Nincs upstream rendszer",
        "noDownstream": "Nincs downstream rendszer",
        "view3d": "3D",
        "viewList": "Lista",
        "viewFlow": "Folyamat",
        "fullscreen": "Teljes képernyő",
        "exitFullscreen": "Kilépés a teljes képernyőből",
        "resetView": "Nézet visszaállítása",
        "pause": "Forgás szüneteltetése",
        "play": "Forgás folytatása",
        "linkInteractions": "{{count}} interakció",
        "linkInteractions_other": "{{count}} interakció"
      },
      "mediaBreakMap": {
        "title": "Médiatörés térkép",
        "breaksBefore": "Törések előtte",
        "breaksAfter": "Törések utána",
        "mostFrequent": "Leggyakoribb törések",
        "foundInProcesses": "{{count}} folyamatban található"
      },
      "deletePhrase": "ezt a rendszert"
    },
    "departments": {
      "title": "Osztályok",
      "description": "A szervezet összes osztályának áttekintése",
      "empty": "Nem található osztály",
      "search": "Osztályok keresése...",
      "members": "Személyek",
      "noMembersFound": "Nem található személy",
      "searchMembers": "Személyek keresése...",
      "teams": "Csapatok",
      "noTeamsFound": "Nincs csapat ebben az osztályban",
      "searchTeams": "Csapatok keresése...",
      "headOfDepartment": "Osztályvezető",
      "abbreviation": "Rövidítés",
      "create": "Osztály létrehozása",
      "editDepartment": "Osztály szerkesztése",
      "createDepartmentDescription": "Új osztály hozzáadása a szervezethez",
      "editDepartmentDescription": "Az osztály adatainak frissítése",
      "namePlaceholder": "Adja meg az osztály nevét",
      "descriptionPlaceholder": "Adja meg az osztály leírását",
      "parentDepartment": "Szülő osztály",
      "selectParent": "Szülő osztály kiválasztása",
      "manager": "Menedzser",
      "selectManager": "Menedzser kiválasztása",
      "relationships": "Hozzárendelés",
      "notFound": "Osztály nem található",
      "detailDescription": "Osztály részleteinek megtekintése és kezelése",
      "details": "Osztály részletei",
      "bulkUpload": "Tömeges feltöltés",
      "bulkUploadPage": {
        "title": "Osztályok tömeges feltöltése",
        "description": "Több osztály feltöltése Excelből hierarchikus kapcsolatokkal",
        "uploadFromExcel": "Feltöltés Excelből",
        "downloadTemplate": "Sablon letöltése",
        "draftDepartments": "Vázlat osztályok",
        "createAll": "Összes létrehozása",
        "cancel": "Mégse",
        "fixErrorsWarning": "Kérjük, javítsa az összes hibát a beküldés előtt",
        "successCreated": "{{count}} osztály sikeresen létrehozva",
        "validationError": "Az érvényesítés sikertelen. Kérjük, javítsa a hibákat és próbálja újra",
        "circularDependency": "Körkörös függőség észlelve az osztályhierarchiában",
        "parentInBatch": "A szülő ebben a kötegben lesz létrehozva",
        "parentInDatabase": "A szülő létezik az adatbázisban",
        "parentNotFound": "Szülő osztály nem található",
        "creationOrder": "Létrehozási sorrend",
        "rowNumber": "Sor #",
        "noDrafts": "Nincsenek vázlat osztályok. Töltse fel Excelből vagy adja hozzá manuálisan.",
        "uploadSuccess": "{{count}} osztály sikeresen feldolgozva",
        "uploadPartial": "{{valid}} érvényes és {{invalid}} érvénytelen osztály feldolgozva",
        "uploadAllInvalid": "Mind a {{count}} osztály hibás",
        "fileInvalidFormat": "Érvénytelen fájlformátum. Kérjük, töltsön fel Excel fájlt (.xlsx vagy .xls)",
        "uploadError": "Hiba az Excel fájl feltöltésekor",
        "addManually": "Manuális hozzáadás",
        "addManuallyDescription": "Egyetlen osztály hozzáadása a köteghez",
        "editDraft": "Vázlat osztály szerkesztése",
        "editDraftDescription": "Osztály adatainak módosítása",
        "confirmDeleteDraft": "Eltávolítja ezt az osztályt a feltöltésből?",
        "parentComboPlaceholder": "Válasszon meglévőt vagy írja be a köteg rövidítését",
        "managerEmailPlaceholder": "vezeto@pelda.hu",
        "validationErrors": "Érvényesítési hibák",
        "instruction1": "Kötelező mezők: Név és Rövidítés",
        "instruction2": "A Szülő rövidítés hivatkozhat meglévő osztályokra vagy a feltöltésben szereplő osztályokra",
        "instruction3": "Kerülje a körkörös függőségeket (A → B → A)",
        "instruction4": "A Menedzser e-mail címnek egy létező rendszerfelhasználónak kell megfelelnie",
        "circularDependencyReview": "Kérjük, ellenőrizze a szülő-gyermek kapcsolatokat, hogy ne legyenek körkörös függőségek.",
        "useBatchAbbreviation": "\"{{abbreviation}}\" használata batch rövidítésként",
        "existingDepartments": "Meglévő osztályok (Adatbázis)",
        "batchDepartments": "Batch osztályok (Jelenlegi feltöltés)"
      },
      "deletePhrase": "ezt az osztályt"
    },
    "orgFunctions": {
      "details": "Funkció részletei",
      "namePlaceholder": "Adja meg a funkció nevét",
      "emailPlaceholder": "Adja meg az e-mail-címet",
      "descriptionPlaceholder": "Adja meg a leírást",
      "selectDepartment": "Válasszon osztályt",
      "noDepartment": "Nincs osztály",
      "selectLead": "Válasszon funkcióvezetőt",
      "selectTeamLead": "Válasszon csapatvezetőt",
      "noLead": "Nincs funkcióvezető",
      "noTeamLead": "Nincs csapatvezető",
      "email": "Megosztott postafiók",
      "lead": "Funkcióvezető",
      "teamLead": "Csapatvezető",
      "department": "Osztály",
      "kind": {
        "label": "Típus",
        "team": "Csapat",
        "role": "Funkció"
      },
      "members": {
        "title": "Személyek",
        "empty": "Nem található személy",
        "search": "Személyek keresése...",
        "leadBadge": "Funkcióvezető",
        "label": "Személyek (további funkció)",
        "hint": "A kiválasztott személyek a pozíciójuk mellett további funkcióként kapják meg ezt a funkciót.",
        "hintMainRoleLocked": "Azok a személyek, akiknek a pozíciója ez a funkció, előre kiválasztva és zárolva jelennek meg.",
        "available": "Elérhető személyek",
        "selected": "Kiválasztott személyek",
        "filterByDepartment": "Szűrés osztály szerint",
        "loadError": "Nem sikerült betölteni a funkcióhoz tartozó személyeket. Zárja be az ablakot, és próbálja újra a szerkesztésükhöz.",
        "mainRoleLocked": "Ez a funkció pozícióként van hozzárendelve, és itt nem távolítható el – ehelyett módosítsa a személy pozícióját."
      },
      "memberCount": "Személyek",
      "deletePhrase": {
        "team": "ezt a csapatot",
        "role": "ezt a funkciót"
      }
    },
    "functions": {
      "title": "Funkciók",
      "description": "A szervezet összes funkciójának kezelése",
      "empty": "Nem található funkció",
      "search": "Funkciók keresése...",
      "create": "Funkció létrehozása",
      "createDescription": "Új funkció hozzáadása a szervezethez",
      "edit": "Funkció szerkesztése",
      "editDescription": "A funkció adatainak frissítése",
      "detailDescription": "Funkció részleteinek megtekintése",
      "notFound": "Funkció nem található"
    },
    "teams": {
      "title": "Csapatok",
      "description": "A szervezet összes csapatának kezelése",
      "empty": "Nem található csapat",
      "search": "Csapatok keresése...",
      "create": "Csapat létrehozása",
      "createDescription": "Új csapat hozzáadása a szervezethez",
      "edit": "Csapat szerkesztése",
      "editDescription": "A csapat adatainak frissítése",
      "detailDescription": "Csapat részleteinek megtekintése",
      "notFound": "Csapat nem található"
    },
    "myOrgFunctions": {
      "title": "Funkcióim",
      "description": "Tekintse meg, mely funkciókban és csapatokban tevékenykedik a vállalatánál.",
      "empty": "Még nem rendeltek Önhöz funkciót."
    },
    "members": {
      "title": "Személyek",
      "description": "A szervezet összes munkatársának áttekintése",
      "empty": "Nem található személy",
      "search": "Személyek keresése...",
      "createMember": "Személy létrehozása",
      "inviteAllInactive": "Összes inaktív felhasználó meghívása",
      "inviteAllInactiveConfirm": "Meghívó e-mailek küldése {{count}} inaktív felhasználónak?",
      "inviteAllInactiveSuccess": "{{count}} meghívó elküldve",
      "inviteAllInactiveSkipped": "{{count}} felhasználó kihagyva",
      "editMember": "Személy szerkesztése",
      "createMemberDescription": "Új személy hozzáadása a szervezethez",
      "editMemberDescription": "A személy adatainak frissítése",
      "notFound": "Személy nem található",
      "detailDescription": "Személy részleteinek megtekintése és kezelése",
      "details": "Személy részletei",
      "firstName": "Keresztnév",
      "lastName": "Vezetéknév",
      "firstNamePlaceholder": "Adja meg a keresztnevet",
      "lastNamePlaceholder": "Adja meg a vezetéknevet",
      "emailPlaceholder": "Adja meg az e-mail címet",
      "emailChangeWarning": "Ez megváltoztatja azt az e-mail-címet, amellyel ez a személy bejelentkezik.",
      "relationships": "Hozzárendelés",
      "selectDepartment": "Osztály kiválasztása",
      "mainRole": "Pozíció",
      "selectMainRole": "Pozíció kiválasztása",
      "secondaryRoles": "További funkciók",
      "selectSecondaryRoles": "További funkciók kiválasztása",
      "location": "Telephely",
      "selectLocation": "Telephely kiválasztása",
      "accessPermissions": "Hozzáférés és jogosultságok",
      "selectUserTypes": "Felhasználótípusok kiválasztása",
      "selectClassification": "Besorolás kiválasztása",
      "externalOrganization": "Külső szervezet",
      "externalOrgPlaceholder": "Adja meg a külső szervezet nevét",
      "sendInvitation": "Meghívó e-mail küldése",
      "sendInvitationHelper": "A személy e-mailben értesítést kap.",
      "statusActions": "Műveletek",
      "sendInvitationAction": "Meghívó küldése",
      "resendInvitationAction": "Meghívó újraküldése",
      "userInactive": "Ez a felhasználó még nem lett meghívva",
      "userPendingInvitation": "Ez a felhasználó a fiók aktiválására vár. Szükség esetén újraküldheti a meghívót.",
      "userSuspended": "Ez a felhasználó jelenleg felfüggesztett",
      "suspendUser": "Felhasználó felfüggesztése",
      "unsuspendUser": "Felfüggesztés feloldása",
      "sendInvitationSuccess": "Meghívó elküldve",
      "suspendSuccess": "Felhasználó felfüggesztve",
      "unsuspendSuccess": "Felfüggesztés feloldva",
      "suspendUserPrompt": "A felhasználó felfüggesztésével ideiglenesen visszavonhatja hozzáférését",
      "resetSignInAction": "Bejelentkezés alaphelyzetbe állítása",
      "resetSignInDescription": "{{name}} ({{email}}) jelenlegi bejelentkezési módjai – jelszó, passkey-k, hitelesítő alkalmazások – megszűnnek működni, és a személyt minden munkaterületről kijelentkeztetjük. E-mailt kap a bejelentkezés újbóli beállításához, és addig nem tud bejelentkezni.",
      "resetSignInConfirmInstruction": "Írja be a <strong /> nevet az alaphelyzetbe állítás megerősítéséhez.",
      "resetSignInConfirmLabel": "A személy neve",
      "resetSignInSuccess": "A bejelentkezés alaphelyzetbe állítva. Az újbóli beállításhoz szükséges e-mailt elküldtük.",
      "homeOrgDeletedBadge": "Otthoni szervezet törölve",
      "homeOrgDeletedTooltip": "A tag otthoni szervezete törölve lett — a bejelentkezés blokkolva van (vagy hamarosan blokkolva lesz). Egy platform-adminisztrátor új otthoni szervezetet rendelhet hozzá a hozzáférés helyreállításához.",
      "deletePhrase": "ezt a személyt"
    },
    "contacts": {
      "title": "Külső kapcsolatok",
      "description": "Összes külső kapcsolat áttekintése",
      "empty": "Nem található külső kapcsolat",
      "search": "Külső kapcsolatok keresése...",
      "create": "Kapcsolat létrehozása",
      "notFound": "Kapcsolat nem található",
      "detailDescription": "Kapcsolat részleteinek megtekintése és kezelése",
      "details": "Kapcsolat részletei",
      "deletePhrase": "ezt a kapcsolatot"
    },
    "externalContacts": {
      "createContact": "Kapcsolat létrehozása",
      "editContact": "Kapcsolat szerkesztése",
      "createContactDescription": "Új külső kapcsolat hozzáadása",
      "editContactDescription": "A kapcsolat adatainak frissítése",
      "nameLabel": "Kapcsolattartó neve",
      "typeSectionLabel": "Kapcsolattípus",
      "typeLabel": "Kapcsolattípus (válasszon a listából vagy hozzon létre újat)",
      "namePlaceholder": "Adja meg a kapcsolat nevét (pl. Mintabank, magánügyfél)",
      "typePlaceholder": "Kapcsolattípus kiválasztása",
      "descriptionPlaceholder": "Adja meg a leírást",
      "types": {
        "customer": "Ügyfél",
        "partner": "Partner",
        "vendor": "Szállító",
        "other": "Egyéb"
      }
    },
    "artifacts": {
      "title": "Dokumentumok",
      "description": "A szervezet folyamataiban használt összes dokumentum áttekintése",
      "empty": "Nem található dokumentum",
      "search": "Dokumentumok keresése...",
      "size": "Méret",
      "createdBy": "Létrehozta",
      "type": "Fájlformátum",
      "fileUrl": "Hivatkozás a dokumentumra",
      "create": "Dokumentum létrehozása",
      "editArtifact": "Dokumentum szerkesztése",
      "createArtifactDescription": "Új dokumentum hozzáadása",
      "editArtifactDescription": "A dokumentum adatainak frissítése",
      "namePlaceholder": "pl. Ügyfél-besorolási ellenőrzőlista",
      "descriptionPlaceholder": "pl. Ellenőrzőlista az ügyfél-besoroláshoz.",
      "typePlaceholder": "pl. PDF, Excel, Word",
      "fileUrlPlaceholder": "https://pelda.hu/fajl.pdf",
      "notFound": "Dokumentum nem található",
      "detailDescription": "Dokumentum részleteinek megtekintése és kezelése",
      "details": "Dokumentum részletei",
      "addNew": "Új hozzáadása",
      "types": {
        "document": "Dokumentum",
        "image": "Kép",
        "video": "Videó",
        "other": "Egyéb"
      },
      "deletePhrase": "ezt a dokumentumot"
    }
  },
  "organizations": {
    "Level": "Szint",
    "Abbreviation": "Rövidítés",
    "Description": "Leírás",
    "ParentDepartment": "Szülő osztály"
  },
  "OrgSettingPage": {
    "Settings": "Beállítások",
    "editKeyDetails": "A szervezet beállításainak konfigurálása",
    "OrganizationLogo": "Szervezeti logó",
    "Upload": "Feltöltés",
    "Organizationname": "Szervezet neve",
    "Language": "Nyelv",
    "RecordingTime": "Alapértelmezett rögzítési idő (óra)",
    "recordingTimeHint": "Mennyi idő teljen el, mielőtt egy hozzárendelt folyamatlépés-rögzítés „lejártnak” számít?",
    "reviewTimeFrame": "Szabványos folyamat-felülvizsgálati időkeret",
    "reviewTimeFrameHint": "Hány nap elteltével szeretné újra rögzíteni ugyanazt a folyamatot, hogy lássa, változott-e?",
    "RatingAndComment": "Értékelés és megjegyzés",
    "FrequencyMeasurement": "Gyakoriság mérése",
    "DurationMeasurement": "Időtartam mérése",
    "VariantCheck": "Változatellenőrzés",
    "SettingSaved": "Beállítások sikeresen mentve.",
    "ExportData": "Adatok exportálása",
    "ExportDataSuccess": "Adatok sikeresen exportálva!",
    "days": "Napok",
    "hours": "óra",
    "logoUploadHint": "SVG, PNG, JPG vagy GIF (max. 800x800px) vagy 3MB",
    "fieldRequired": "A mező kitöltése kötelező.",
    "noCommaAllowed": "Az érték nem tartalmazhat vesszőt.",
    "mustBePositive": "Az értéknek nagyobbnak kell lennie 0-nál.",
    "internalBillingRate": "Belső elszámolási díj",
    "internalBillingRateUnit": "€/óra",
    "languageEnglish": "English",
    "languageGerman": "Deutsch",
    "languageHungarian": "Magyar",
    "languageFrench": "Français",
    "organizationProfileTitle": "Szervezeti profil",
    "organizationProfileDesc": "A szervezet logójának és arculatának kezelése",
    "preferencesTitle": "Beállítások",
    "preferencesDesc": "Adja meg a szervezet alapértelmezett értékeit.",
    "surveySettingsTitle": "Felmérés beállítások",
    "surveySettingsDesc": "Annak vezérlése, hogy a rögzítés után mely felmérések jelenjenek meg a személyeknek, és mely értékeket kérdezzen le",
    "capacityPriority": "Kapacitásforrás",
    "capacityPrioritySurveyFirst": "Először a felmért érték",
    "capacityPrioritySurveyFirstDesc": "A felmért érték; ha nincs ilyen, a kézzel megadott érték számít.",
    "capacityPriorityManualFirst": "Először a kézi érték",
    "capacityPriorityManualFirstDesc": "A kézzel megadott érték; ha nincs ilyen, a felmért érték számít.",
    "capacityPrioritySurveyOnly": "Csak felmért",
    "capacityPrioritySurveyOnlyDesc": "Csak a felmért értékek számítanak. A kézi értékek tárolva maradnak.",
    "capacityPriorityManualOnly": "Csak kézi",
    "capacityPriorityManualOnlyDesc": "Csak a kézzel megadott értékek számítanak. A felmért értékek tárolva maradnak.",
    "privacyMode": "Folyamat láthatóság",
    "privacyNeedToKnow": "Szükséges ismeret",
    "privacyNeedToKnowDesc": "A felhasználók csak a hozzájuk rendelt folyamatokat látják",
    "privacyFullTransparency": "Teljes átláthatóság",
    "privacyFullTransparencyDesc": "Minden felhasználó láthatja az összes folyamatot",
    "ai": {
      "title": "AI funkciók",
      "description": "AI-alapú funkciók engedélyezése és konfigurálása a szervezet számára",
      "bliksyEnableLabel": "Bliksy engedélyezése",
      "bliksyEnableDescription": "Felhasználók számára lehetővé teszi a Bliksy AI asszisztens használatát rögzítés közben",
      "stepNameGenerationLabel": "Lépésnevek automatikus generálása",
      "stepNameGenerationDescription": "Rögzített folyamatlépések neveinek és leírásainak automatikus generálása AI segítségével",
      "appsTitle": "Az alkalmazások AI-funkciói",
      "appsDescription": "A szervezet alkalmazásainak egyes AI-funkcióit itt kapcsolhatod be vagy ki. A kikapcsolt funkciót az alkalmazás elrejti."
    }
  },
  "department": {
    "tabs": {
      "members": "Személyek",
      "teams": "Csapatok"
    },
    "selector": {
      "placeholder": "Osztály kiválasztása..."
    },
    "members": {
      "title": "Személyek az osztályomon",
      "description": "A(z) {{department}} osztály személyeinek kezelése",
      "descriptionDefault": "Az Ön osztálya személyeinek kezelése",
      "empty": "Nem találhatók személyek az osztályában",
      "search": "Személyek keresése...",
      "createMember": "Személy hozzáadása"
    },
    "teams": {
      "title": "Osztályom csapatai",
      "description": "A(z) {{department}} osztály csapatainak kezelése",
      "descriptionDefault": "Az Ön osztálya csapatainak kezelése",
      "empty": "Az Ön osztályain nincsenek állandó csapatok",
      "search": "Csapatok keresése...",
      "createTeam": "Csapat hozzáadása",
      "noAccess": "Ön nem kezel egyetlen osztályt sem."
    }
  },
  "organizationSettings": {
    "userManagement": {
      "title": "Felhasználókezelés",
      "description": "Felhasználói hozzáférés, típusok és jogosultságok kezelése a szervezet számára."
    },
    "softwareList": {
      "title": "Szoftverlista",
      "description": "A szervezet által használt szoftverrendszerek kezelése és konfigurálása.",
      "create": "Rendszer létrehozása",
      "empty": "Nem található rendszer"
    }
  }
}
